export const HexagonMesh = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20 z-0">
      {/* SVG Hexagon Pattern */}
      <svg className="absolute inset-0 w-full h-full">
        <defs>
          <pattern id="hexPattern" width="60" height="52" patternUnits="userSpaceOnUse" patternTransform="scale(1)">
            <polygon 
              points="30,0 52,15 52,37 30,52 8,37 8,15" 
              fill="none" 
              stroke="hsl(var(--neon-glow))" 
              strokeWidth="0.5"
              opacity="0.3"
            />
          </pattern>
          
          <radialGradient id="hexGradient" cx="50%" cy="50%">
            <stop offset="0%" stopColor="hsl(var(--neon-glow))" stopOpacity="0.2" />
            <stop offset="100%" stopColor="transparent" stopOpacity="0" />
          </radialGradient>
        </defs>
        
        <rect width="100%" height="100%" fill="url(#hexPattern)" />
        <circle cx="50%" cy="50%" r="40%" fill="url(#hexGradient)" />
      </svg>

      {/* Animated Connection Lines - Desktop only */}
      <svg className="hidden md:block absolute inset-0 w-full h-full">
        <line 
          x1="10%" y1="20%" x2="40%" y2="60%" 
          stroke="hsl(var(--neon-glow))" 
          strokeWidth="1" 
          opacity="0.4"
        >
          <animate attributeName="opacity" values="0.2;0.6;0.2" dur="3s" repeatCount="indefinite" />
        </line>
        <line 
          x1="60%" y1="30%" x2="90%" y2="70%" 
          stroke="hsl(var(--radiant-blue))" 
          strokeWidth="1" 
          opacity="0.4"
        >
          <animate attributeName="opacity" values="0.2;0.6;0.2" dur="4s" repeatCount="indefinite" />
        </line>
        <circle cx="40%" cy="60%" r="3" fill="hsl(var(--neon-glow))">
          <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" repeatCount="indefinite" />
        </circle>
        <circle cx="90%" cy="70%" r="3" fill="hsl(var(--radiant-blue))">
          <animate attributeName="opacity" values="0.3;1;0.3" dur="2.5s" repeatCount="indefinite" />
        </circle>
      </svg>

      {/* Molecular Dots - Fewer on mobile, more on desktop */}
      {[...Array(5)].map((_, i) => (
        <div
          key={i}
          className="absolute w-1 h-1 rounded-full bg-neon-glow md:animate-glow-pulse"
          style={{
            left: `${20 + Math.random() * 60}%`,
            top: `${20 + Math.random() * 60}%`,
            animationDelay: `${Math.random() * 2}s`,
            opacity: Math.random() * 0.4 + 0.2,
            boxShadow: '0 0 10px hsl(var(--neon-glow))',
          }}
        />
      ))}
    </div>
  );
};
